import { defineMessages } from 'react-intl';

export const messages: {
	linkExternalIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	linkExternalIconLabel: {
		id: 'navigation.global-side-navigation.more-menu-item.link-external-item-label',
		description: 'Label for the link external icon',
		defaultMessage: 'Open external link icon',
	},
});
